(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vaulted-watch-intake"] && !Shopify.designMode) return;
  try {
    
  function initializeVaultedIntake(form) {
    if (form.dataset.vaultedIntakeReady === 'true') return;
    form.dataset.vaultedIntakeReady = 'true';

    const phone = form.querySelector('[name="contact[phone]"]');
    const contactMethod = form.querySelector('[name="contact[Preferred contact method]"]');
    const transactionalSmsOptIn = form.querySelector('[data-transactional-sms-opt-in]');
    const emailOptIn = form.querySelector('[data-email-opt-in]');
    const smsOptIn = form.querySelector('[data-sms-opt-in]');
    const emailConsentValue = form.querySelector('[data-email-consent-value]');
    const smsConsentValue = form.querySelector('[data-sms-consent-value]');
    const transactionalSmsValue = form.querySelector('[data-transactional-sms-value]');
    const phoneNote = form.querySelector('[data-phone-note]');
    const textConsentNote = form.querySelector('[data-text-consent-note]');
    const successMessage = form.querySelector('[data-vaulted-intake-success]');
    const ajaxSuccess = form.querySelector('[data-vaulted-ajax-success]');
    const successReference = form.querySelector('[data-vaulted-success-reference]');
    const inquiryReference = form.querySelector('[data-inquiry-reference]');
    const photoInput = form.querySelector('[data-vaulted-photo-input]');
    const photoList = form.querySelector('[data-vaulted-photo-list]');
    const errorPanel = form.querySelector('[data-vaulted-error]');
    const errorMessage = form.querySelector('[data-vaulted-error-message]');
    const submitStatus = form.querySelector('[data-vaulted-submit-status]');
    const submitButton = form.querySelector('button[type="submit"]');
    let selectedPhotos = [];
    let uploadedPhotos = [];
    let uploadedSignature = '';

    if (successMessage) {
      requestAnimationFrame(() => {
        successMessage.focus({ preventScroll: true });
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const updatePhoneRequirement = () => {
      const methodNeedsPhone = contactMethod && contactMethod.selectedOptions[0]?.dataset.needsPhone === 'true';
      const smsNeedsPhone = Boolean(transactionalSmsOptIn?.checked || smsOptIn?.checked);
      const phoneRequired = methodNeedsPhone || smsNeedsPhone;

      if (phone) phone.required = phoneRequired;
      if (phoneNote) phoneNote.hidden = !phoneRequired;
    };

    const updateTextConsentRequirement = () => {
      const textMessageSelected = contactMethod && contactMethod.selectedOptions[0]?.dataset.needsSmsConsent === 'true';

      if (textConsentNote) textConsentNote.hidden = !textMessageSelected;
      if (transactionalSmsOptIn) {
        transactionalSmsOptIn.setCustomValidity(
          textMessageSelected && !transactionalSmsOptIn.checked
            ? form.dataset.textConsentRequired || 'Choose the inquiry text-message consent to use text as your preferred contact method.'
            : ''
        );
      }
    };

    const updateConsentValues = () => {
      if (emailOptIn && emailConsentValue) {
        emailConsentValue.value = emailOptIn.checked ? emailOptIn.dataset.consentYes : emailOptIn.dataset.consentNo;
      }

      if (smsOptIn && smsConsentValue) {
        smsConsentValue.value = smsOptIn.checked ? smsOptIn.dataset.consentYes : smsOptIn.dataset.consentNo;
      }
    };

    const updateTransactionalSmsValue = () => {
      if (!transactionalSmsOptIn || !transactionalSmsValue) return;

      const transactionalSmsRequested = transactionalSmsOptIn.checked;
      transactionalSmsValue.value = transactionalSmsRequested
        ? transactionalSmsValue.dataset.consentYes
        : transactionalSmsValue.dataset.consentNo;
    };

    const populateAttribution = () => {
      const currentUrl = new URL(window.location.href);
      const referrerInput = form.querySelector('[data-attribution-referrer]');

      if (referrerInput) referrerInput.value = document.referrer;

      form.querySelectorAll('[data-attribution-param]').forEach((input) => {
        input.value = currentUrl.searchParams.get(input.dataset.attributionParam) || '';
      });
    };

    const createInquiryReference = () => {
      const date = new Date().toISOString().slice(0, 10).replaceAll('-', '');
      const tokenSource = window.crypto?.getRandomValues
        ? (() => {
            const random = new Uint32Array(2);
            window.crypto.getRandomValues(random);
            return `${random[0].toString(36)}${random[1].toString(36)}`;
          })()
        : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      const token = tokenSource
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .padEnd(8, '0')
        .slice(0, 8);
      return `VW-${date}-${token}`;
    };

    const photoType = (file) => {
      if (['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'].includes(file.type)) {
        return file.type;
      }
      const extension = file.name.split('.').pop()?.toLowerCase();
      return {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        webp: 'image/webp',
        heic: 'image/heic',
        heif: 'image/heif'
      }[extension] || '';
    };

    const setError = (message) => {
      if (!errorPanel || !errorMessage) return;
      errorMessage.textContent = message;
      errorPanel.hidden = false;
      errorPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const clearError = () => {
      if (errorPanel) errorPanel.hidden = true;
      if (errorMessage) errorMessage.textContent = '';
    };

    const setStatus = (message) => {
      if (submitStatus) submitStatus.textContent = message;
    };

    const selectedPhotoSignature = () => selectedPhotos
      .map((file) => `${file.name}:${file.size}:${file.lastModified}`)
      .join('|');

    const syncPhotoInput = () => {
      if (!photoInput || typeof DataTransfer === 'undefined') return;
      const transfer = new DataTransfer();
      selectedPhotos.forEach((file) => transfer.items.add(file));
      photoInput.files = transfer.files;
    };

    const renderPhotoList = () => {
      if (!photoList) return;
      photoList.replaceChildren();
      selectedPhotos.forEach((file, index) => {
        const item = document.createElement('div');
        item.className = 'vaulted-intake__photo-item';

        const image = document.createElement('img');
        image.src = URL.createObjectURL(file);
        image.alt = file.name;
        image.addEventListener('load', () => URL.revokeObjectURL(image.src), { once: true });

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = form.dataset.vaultedRemove || 'Remove';
        remove.setAttribute('aria-label', `${remove.textContent} ${file.name}`);
        remove.addEventListener('click', () => {
          selectedPhotos.splice(index, 1);
          uploadedPhotos = [];
          uploadedSignature = '';
          syncPhotoInput();
          renderPhotoList();
        });

        item.append(image, remove);
        photoList.append(item);
      });
    };

    const readValue = (name) => form.elements.namedItem(name)?.value?.trim() || '';

    const uploadSelectedPhotos = async () => {
      if (!selectedPhotos.length) return [];
      const signature = selectedPhotoSignature();
      if (signature === uploadedSignature && uploadedPhotos.length === selectedPhotos.length) {
        return uploadedPhotos;
      }
      if (!window.VaultedBlob?.upload) {
        throw new Error('The secure photo uploader did not load. Please refresh the page and try again.');
      }

      const results = [];
      for (let index = 0; index < selectedPhotos.length; index += 1) {
        const file = selectedPhotos[index];
        const contentType = photoType(file);
        setStatus(`${form.dataset.vaultedUploading || 'Uploading photographs…'} ${index + 1} of ${selectedPhotos.length}`);
        const safeName = file.name.normalize('NFKD').replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/^[.-]+|[.-]+$/g, '').slice(0, 180) || 'watch-photo';
        const pathname = `vaulted-watch-inquiries/${inquiryReference.value.toLowerCase()}/${safeName}`;
        const blob = await window.VaultedBlob.upload(pathname, file, {
          access: 'private',
          contentType,
          multipart: file.size > 4 * 1024 * 1024,
          handleUploadUrl: form.dataset.vaultedUploadUrl,
          clientPayload: JSON.stringify({
            inquiryReference: inquiryReference.value,
            originalName: file.name
          })
        });
        results.push({
          url: blob.url,
          downloadUrl: blob.downloadUrl,
          pathname: blob.pathname,
          contentType,
          size: file.size,
          originalName: file.name
        });
      }

      uploadedPhotos = results;
      uploadedSignature = signature;
      return results;
    };

    const buildPayload = (photos) => ({
      inquiryReference: inquiryReference.value,
      transactionType: readValue('contact[Transaction type]'),
      name: readValue('contact[name]'),
      email: readValue('contact[email]'),
      phone: readValue('contact[phone]'),
      location: readValue('contact[location]'),
      preferredContactMethod: readValue('contact[Preferred contact method]'),
      watchBrand: readValue('contact[Watch brand]'),
      watchModel: readValue('contact[Watch model]'),
      referenceNumber: readValue('contact[Reference number]'),
      approximateYear: readValue('contact[Approximate year]'),
      condition: readValue('contact[Condition]'),
      boxAndPapers: readValue('contact[Box and papers]'),
      serviceHistory: readValue('contact[Service history]'),
      targetValue: readValue('contact[Target value]'),
      details: readValue('contact[body]'),
      photos,
      submittedFrom: window.location.href,
      referrerUrl: readValue('contact[Referrer URL]'),
      utmSource: readValue('contact[UTM source]'),
      utmMedium: readValue('contact[UTM medium]'),
      utmCampaign: readValue('contact[UTM campaign]'),
      utmContent: readValue('contact[UTM content]'),
      utmTerm: readValue('contact[UTM term]'),
      emailMarketingOptIn: Boolean(emailOptIn?.checked),
      smsMarketingOptIn: Boolean(smsOptIn?.checked),
      transactionalSmsRequested: Boolean(transactionalSmsOptIn?.checked),
      consentCopy: '2026-09-29',
      company: readValue('company')
    });

    const showAjaxSuccess = (reference) => {
      form.querySelectorAll(':scope > fieldset, :scope > .vaulted-intake__submit, :scope > .vaulted-intake__error')
        .forEach((element) => { element.hidden = true; });
      if (successReference) successReference.textContent = reference;
      if (ajaxSuccess) {
        ajaxSuccess.hidden = false;
        ajaxSuccess.focus({ preventScroll: true });
        ajaxSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    photoInput?.addEventListener('change', () => {
      clearError();
      const files = Array.from(photoInput.files || []);
      if (files.length > 8) {
        photoInput.value = '';
        selectedPhotos = [];
        setError('Please choose no more than 8 photographs.');
        renderPhotoList();
        return;
      }
      const invalid = files.find((file) => !photoType(file) || file.size > 15 * 1024 * 1024);
      if (invalid) {
        photoInput.value = '';
        selectedPhotos = [];
        setError(`${invalid.name} is not a supported image or is larger than 15 MB.`);
        renderPhotoList();
        return;
      }
      selectedPhotos = files;
      uploadedPhotos = [];
      uploadedSignature = '';
      renderPhotoList();
    });

    form.addEventListener('submit', async (event) => {
      if (!form.dataset.vaultedSubmitUrl || successMessage) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      clearError();
      if (!form.reportValidity()) return;

      const originalButton = submitButton?.innerHTML;
      if (submitButton) submitButton.disabled = true;
      try {
        const photos = await uploadSelectedPhotos();
        setStatus(form.dataset.vaultedSubmitting || 'Saving your inquiry…');
        const response = await fetch(form.dataset.vaultedSubmitUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(buildPayload(photos))
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || !result.ok) {
          throw new Error(result.error || 'Please try again.');
        }
        setStatus('');
        showAjaxSuccess(result.reference || inquiryReference.value);
      } catch (error) {
        setStatus('');
        setError(error instanceof Error ? error.message : 'Please try again.');
        if (submitButton) submitButton.disabled = false;
        if (submitButton && originalButton !== undefined) submitButton.innerHTML = originalButton;
      }
    });

    contactMethod?.addEventListener('change', () => {
      updatePhoneRequirement();
      updateTextConsentRequirement();
    });
    transactionalSmsOptIn?.addEventListener('change', () => {
      updatePhoneRequirement();
      updateTransactionalSmsValue();
      updateTextConsentRequirement();
    });
    emailOptIn?.addEventListener('change', updateConsentValues);
    smsOptIn?.addEventListener('change', () => {
      updatePhoneRequirement();
      updateConsentValues();
    });
    updatePhoneRequirement();
    updateTextConsentRequirement();
    updateConsentValues();
    updateTransactionalSmsValue();
    populateAttribution();
    if (inquiryReference && !inquiryReference.value) inquiryReference.value = createInquiryReference();
  }

  document.querySelectorAll('.vaulted-intake__form').forEach(initializeVaultedIntake);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.vaulted-intake__form').forEach(initializeVaultedIntake);
  });

  } catch(e) { console.error(e); }
})();
})();
